import { render } from "./ActivityDetail.vue?vue&type=template&id=4431eae8"
import script from "./ActivityDetail.vue?vue&type=script&lang=js"
export * from "./ActivityDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/erdoganyesil/Sites/Fungi Turkey/FungiTurkey-Admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__